export default __webpack_public_path__ + "static/media/success.aa5f91ce.svg";